import Component from './Component'

export default class Grid extends Component {

	static _type = 'Grid'

	_name
	columns
	mobileColumns
	_list
	_list_ext
	map
	filter_regex = []
	sort_order = []
	selected_rows = []
	_r_first = -1
	_r_last = -1
	_r_rows = {}
	_isMobileView = false
	_contextMenu = null
	_contextMenuMobile = null

	_map_mode = false
	_map_collapse_markers = false
	_leaflet
	_leaflet_markers = []

	constructor (name, list, params = {}) {
		super(params)
		/* Possible params:

		columns: []
		mobileColumns: []
		filters: []
		sort_order: ''

		-- selection
		selection_key: undefined		-> if provided, this field will be used to identify rows when the datasource is reloaded to preserve the selection
		multiselect: false
		hiddenselect: false
		forceselect: false

		-- rendering
		row_height: 44
		row_class: undefined
		render_footer: undefined
		mobile_row_height: null         -> if provided, this will be used as the row height in mobile view
		mobile_breakpoint: 992          -> screen width in pixels below which mobile view is used

		-- events
		onselect: undefined
		ondoubleclick: undefined
		onkeydown: undefined

		-- context menu
		contextmenu: {                  -> configuration for the bootstrap-menu context menu
			items: [                    -> array of menu items
				{
					name: 'Item Name',  -> display name for the menu item
					icon: 'fa-icon',    -> FontAwesome icon class (without the 'fa' prefix)
					action: function,   -> callback function that will receive the selected row(s) as parameter
					enabled: function   -> optional function to determine if the item should be enabled
				}
			]
		}
		*/

		this._name = name
		this.columns = params.columns || []
		this.mobileColumns = params.mobileColumns || []
		if (typeof params.sort_order == 'string') {
			this.sort_order = params.sort_order.split('-').reduce((acc, s) => {
				if (s.length > 0) {
					acc.push({
						column_id: parseInt(s),
						order: (s[s.length - 1] == 'a' ? 'asc' : 'desc')
					})
				}
				return acc
			}, []) || []
		}
		this._list = list

		for (let i = 0; i < this.columns.length; i++) {

			// Default values
			this.columns[i] = Object.assign({
				id: i,
				title: 'Column',
				field: null,
				type: 'default',
				sort: true,
				value: undefined,
				options: {}
			}, this.columns[i])

			// Replace string type references in the column schema
			if (typeof this.columns[i].type == 'string') {
				if (!(this.columns[i].type in Grid.CellTypes))
					throw new Error(`The CellType '${this.columns[i].type}' does not exist.`)

				// Replace the string
				this.columns[i].type = Grid.CellTypes[this.columns[i].type]
			}

			// Set default options
			if ('default_options' in this.columns[i].type) {
				this.columns[i].options = Object.assign({ show_null: false, class: '' }, this.columns[i].type.default_options, this.columns[i].options)
			} else {
				this.columns[i].options = Object.assign({ show_null: false, class: '' }, this.columns[i].options)
			}
		}
	}

	tether () {
		super.tether()

		// Own DOM elements
		this.sizer = this.base.querySelector('.sizer')
		this.content = this.base.querySelector('.grid-list .grid-content')
		this.table = this.base.querySelector('.grid-list .grid-content table')
		this.thead = this.base.querySelector('.grid-list thead')
		this.tbody = this.base.querySelector('.grid-list tbody')
		this.tfoot = this.base.querySelector('.grid-list tfoot')
		this.tfoot_total = this.base.querySelector('.grid-list tfoot .table-display-total')
		this.tfoot_view = this.base.querySelector('.grid-list tfoot .table-display-view')
		this.tfoot_selection = this.base.querySelector('.grid-list tfoot .table-display-selection')
		this.extra_footer = this.base.querySelector('.grid-list .grid-extra-footer')

		$(window).on('resize', this.resizeListener)
		$(this.content).on('scroll', this.scrollListener)
		$(this.base).on('click', 'thead th', this.thClickListener)
		$(this.base).on('contextmenu', 'thead th', this.thContextMenuListener)
		$(this.base).on('click', 'tbody tr', this.trClickListener)
		$(this.base).on('contextmenu', 'tbody tr', this.trContextMenuListener)


		if (this.params.map) {
			// Map mode specific elements (only if map mode is enabled)
			this.tfoot_total_map = this.base.querySelector('.grid-map tfoot .map-display-total')
			this.tfoot_view_map = this.base.querySelector('.grid-map tfoot .map-display-view')
			this.extra_footer_map = this.base.querySelector('.grid-map .grid-extra-footer')
			this.map_collapse_markers = this.base.querySelector('.grid-map .map-display-collapse-markers')

			// Attach listener to the collapse markers checkbox
			$(this.map_collapse_markers).on('change', this.collapseMarkersCheckboxListener)
		}

		// Initialize context menu if provided in params
		if (this.params.contextmenu && this.params.contextmenu.items) {

			// Create the menu
			this._contextMenu = new BootstrapMenu(`[anvil-component="${this.id}"] .grid-content tr.desktop`, {
				menuSource: 'mouse',
				menuPosition: 'belowLeft',
				menuEvent: 'right-click',
				fetchElementData: (target) => {
					const tr = $(target).closest('tr')
					const offset = parseInt(tr.attr('grid_offset'))

					this.select(this.map[offset])

					return this.map[offset]
				},
				actions: this.params.contextmenu.items,
				actionsGroups: this.params.contextmenu.groups || undefined
			})

			this._contextMenuMobile = new BootstrapMenu(`[anvil-component="${this.id}"] .grid-content .mt-context-menu-btn`, {
				menuSource: 'mouse',
				menuPosition: 'belowLeft',
				menuEvent: 'click',
				fetchElementData: (target) => {
					const tr = $(target).closest('tr')
					const offset = parseInt(tr.attr('grid_offset'))

					this.select(this.map[offset])

					return this.map[offset]
				},
				actions: this.params.contextmenu.items,
				actionsGroups: this.params.contextmenu.groups || undefined
			})
		}

		// Initialize the map mode if enabled
		if (this.params.map) {

			// Init leaflet
			this._leaflet = L.map(`${this.id}_map_frame`).setView([ 47.175, 19.485 ], 8)

			// Init tileset for the map
			L.tileLayer('https://tile.openstreetmap.org/{z}/{x}/{y}.png', {
				maxZoom: 19,
				attribution: '&copy; <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a>'
			}).addTo(this._leaflet)
		}

		// Begin the preprocessor
		this.preprocess()
	}

	get name () { return this._name }

	get list () { return this._list }
	set list (value) {
		this._list = value

		// If we have a selection key, we need to restore the selection after the reload
		// Here, we remember the selection
		const selected_keys = []
		if ('selection_key' in this.params) {
			for (let row of this.selected_rows) {
				if (row[this.params.selection_key] !== undefined) {
					selected_keys.push(row[this.params.selection_key])
				}
			}
		}

		// Clear selection (previous references are useless for the new list)
		this.selected_rows = []
		// Update footer
		$(this.tfoot_selection).text(this.selected_rows.length)

		// Restore the selection if possible
		if ('selection_key' in this.params) {
			for (let row of this._list.data) {
				if (selected_keys.includes(row[this.params.selection_key])) {
					this.selected_rows.push(row)
				}
			}
		}

		// Begin the preprocessor
		this.preprocess()
	}

	// Resizing the window
	resizeListener = () => {
		this.render()
	}

	// Scrolling the frame
	scrollListener = () => {
		//console.time('render')
		this.render(true)
		//console.timeEnd('render')
	}

	// Left click on column header
	thClickListener = (event) => {

		// Sort change
		let th = $(event.currentTarget)

		// Get column definition by offset
		let column = this.columns[th.attr('field')]
		if (column.sort) {
			// This column can be sorted

			// Is it aleady on the sort list?
			let item = this.sort_order.find(item => item.column_id === column.id)
			if (typeof item === 'undefined') {
				// This column is not yet on the sort list, so add it
				this.sort_order.push({
					column_id: column.id,
					order: 'asc'
				})
			} else {
				// This column is already on the sort list, change the direction
				item.order = (item.order == 'asc') ? 'desc' : 'asc'
			}

			// Update starting with sort step
			this.sort()
		}
	}

	// Right click on column header
	thContextMenuListener = (event) => {

		// Sort change
		let th = $(event.currentTarget)

		// Get column definition by offset
		let column = this.columns[th.attr('field')]
		if (column.sort) {
			// This column can be sorted

			// Is it on the sort list?
			let index = this.sort_order.findIndex(item => item.column_id === column.id)
			if (index > -1) {
				// Yes, let's remove it
				this.sort_order.splice(index, 1)

				// Update starting with filter step
				this.filter()
			}
		}
	}

	// Left click on a row
	trClickListener = (event) => {

		// Row selection
		let tr = $(event.currentTarget)
		let row = this.map[parseInt(tr.attr('grid_offset'))]

		if (!this.selected_rows.includes(row)) {
			// This row is not selected

			// Are we replacing the current selection?
			if (!event.ctrlKey || this.params.multiselect != true) {
				// Clear previous selection
				this.selected_rows = []
				$(this.tbody).find('tr.selected').removeClass('selected')
			}

			// Let's select it now
			this.selected_rows.push(row)
			tr.addClass('selected')

		} else {
			// This row is selected

			// If we are in toggle selection mode
			if (this.params.multiselect == true && event.ctrlKey) {
				// Deselect
				this.selected_rows.splice(this.selected_rows.indexOf(row), 1)
				tr.removeClass('selected')
			}

			// Otherwise leave it as is
		}

		// Update footer
		$(this.tfoot_selection).text(this.selected_rows.length)

		// See if we have an action set for this
		if ('onselect' in this.params && typeof this.params.onselect == 'function') {
			this.params.onselect(this.selected_rows, this)
		}
	}

	// Right click on row
	trContextMenuListener = (event) => {

		/*
		const tr = $(event.target).closest('tr')
		const offset = parseInt(tr.attr('grid_offset'))
		this.select(this.map[offset])

		return false

		// If there's no context menu configuration, let the browser handle the event
		if (!this.params.contextmenu || !this.params.contextmenu.items || this.params.contextmenu.items.length === 0) {
			return true;
		}

		// Stop the browser's default context menu
		event.preventDefault();

		// The bootstrap-menu plugin will handle the rest
		return false;
		*/
	}

	collapseMarkersCheckboxListener = (event) => {
		this._map_collapse_markers = this.map_collapse_markers.checked
		this.render()
	}

	// Set selection ('rows' must be an array of list element references)
	async select (rows = null, focus = false) {
		// Set new selection
		if (rows == null) {
			this.selected_rows = [ ]
		} else if (Array.isArray(rows)) {
			this.selected_rows = rows
		} else {
			this.selected_rows = [ rows ]
		}

		// Update footer
		$(this.tfoot_selection).text(this.selected_rows.length)

		// See if we have an action set for this
		if ('onselect' in this.params && typeof this.params.onselect == 'function') {
			this.params.onselect(this.selected_rows, this)
		}

		// Focus on first selected element
		if (focus && this.selected_rows.length > 0) {
			// See if the selected element is visible under the current filter
			let offset = this.map.indexOf(this.selected_rows[0])
			if (offset > -1) {
				let fr = $(this.base).height(),				// frame height
					th = $(this.thead).height(),			// thead height
					tf = $(this.tfoot).height(),			// tfoot height
					ct = fr - th - tf,						// content area height
					rh = (('row_height' in this.params) ? this.params.row_height : 28.5)	// row height

				this.content.scrollTop = (rh * offset) - ((ct - rh) / 2)
			}
		}

		// Re-render the grid
		this.render()
	}

	select_first () {
		if (this.map.length == 0) return
		this.select([ this.map[0] ], true)
	}

	select_last() {
		if (this.map.length == 0) return
		this.select([ this.map[this.map.length - 1] ], true)
	}

	select_next_page () {
		if (this.map.length == 0) return
		if (this.selected_rows.length == 0) {
			select_first()
			return
		}
		let offset = this.map.indexOf(this.selected_rows[0])
		if (offset > -1) {
			let fr = $(this.base).height(),				// frame height
				th = $(this.thead).height(),			// thead height
				tf = $(this.tfoot).height(),			// tfoot height
				ct = fr - th - tf,						// content area height
				rh = (('row_height' in this.params) ? this.params.row_height : 28.5)	// row height
			this.select(this.map[Math.max(0, Math.min(this.map.length - 1, offset + Math.floor(ct / rh)))], true)
		}
	}

	select_prev_page () {
		if (this.map.length == 0) return
		if (this.selected_rows.length == 0) {
			select_first()
			return
		}
		let offset = this.map.indexOf(this.selected_rows[0])
		if (offset > -1) {
			let fr = $(this.base).height(),				// frame height
				th = $(this.thead).height(),			// thead height
				tf = $(this.tfoot).height(),			// tfoot height
				ct = fr - th - tf,						// content area height
				rh = (('row_height' in this.params) ? this.params.row_height : 28.5)	// row height
			this.select(this.map[Math.max(0, Math.min(this.map.length - 1, offset - Math.floor(ct / rh)))], true)
		}
	}

	select_next () {
		if (this.map.length == 0) return
		if (this.selected_rows.length == 0) {
			select_first()
			return
		}
		let offset = this.map.indexOf(this.selected_rows[0])
		if (offset > -1) {
			this.select(this.map[Math.max(0, Math.min(this.map.length - 1, offset + 1))], true)
		}
	}

	select_prev () {
		if (this.map.length == 0) return
		if (this.selected_rows.length == 0) {
			select_first()
			return
		}
		let offset = this.map.indexOf(this.selected_rows[0])
		if (offset > -1) {
			this.select(this.map[Math.max(0, Math.min(this.map.length - 1, offset - 1))], true)
		}
	}

	// Preprocess
	preprocess () {
		// Reconstitute the extension cache
		this._list_ext = new WeakMap()

		// Determine columns that need to be calculated
		let ext_columns = this.columns.filter(c => typeof c.value != 'undefined')

		// If we have some columns to calculate, do it
		if (ext_columns.length > 0) {
			for (let row of this._list.data) {
				this._list_ext.set(row, new WeakMap())

				// Calculate row values
				for (let column of ext_columns) {
					// If there is a function that yields the value, execute it
					if (typeof column.value == 'function') {
						this._list_ext.get(row).set(column, column.value(column.field === null ? null : row[column.field], row))
						continue
					}
					// Otherwise, treat it as a primitive
					this._list_ext.get(row).set(column, column.value)
				}
			}
		}

		// Update footer
		$(this.tfoot_total).text(this._list.data.length)
		$(this.tfoot_total_map).text(this._list.data.length)

		// Begin component update with filter step
		this.filter()
	}

	// Update: step 1
	filter (expression, filter_functions) {

        // If we get new filter functions, apply them
        if (filter_functions !== undefined && Array.isArray(filter_functions)) {
            this.params.filters = filter_functions
        }

		// If we get a new expression, let's prepare the RegExp object
		if (expression !== undefined) {

			// Sanitize
			expression = (expression + '').trim()

			// Convert to regexp
			this.filter_regex = []
			if (expression != '') {

				const tokens = expression.split(' ').map(x => x.trim()).filter(x => x.length > 0)

				// Useful expression
				for (let token of tokens) {
					let exp = ''
					for (let char of token) {
						// Multi-char substitution
						if (char == '*') {
							exp += '.{1,}'
							continue
						}
						// Single-char substitution
						if (char == '?') {
							exp += '.'
							continue
						}
						// Accents
						if (['a','á'].includes(char)) {
							exp += `[aá]`
							continue
						}
						if (['e','é'].includes(char)) {
							exp += `[eé]`
							continue
						}
						if (['i','í'].includes(char)) {
							exp += `[ií]`
							continue
						}
						if (['o','ó'].includes(char)) {
							exp += `[oó]`
							continue
						}
						if (['ö','ő'].includes(char)) {
							exp += `[öő]`
							continue
						}
						if (['u','ú'].includes(char)) {
							exp += `[uú]`
							continue
						}
						if (['ü','ű'].includes(char)) {
							exp += `[üű]`
							continue
						}
						// Regex special characters
						if (['\\', '^', '$', '.', '|', '?', '*', '+', '(', ')', '[', ']', '{', '}'].includes(char)) {
							exp += '\\' + char
							continue
						}
						// Everything else
						exp += char
					}
					this.filter_regex.push(new RegExp(exp, 'gmi'))
				}
			}
		}

		// Get a reference array
		var map = this._list.data.map(x => x)

		// Apply function based filters
		if (this.params.filters) for (const filter_function of this.params.filters) {
			map = map.filter(filter_function)
		}

		// Apply text filter
		if (this.filter_regex.length == 0) {
			// We have no filter regex, just clone the reference array
			this.map = map
		} else {
			// Create a filtered reference array
			this.map = map.filter((row) => {
				// For every row..
				return this.filter_regex.every((regex) => {
					// For every regex..
					for (let column of this.columns) {
						// Check every relevant field for a match
						if (typeof column.value !== 'undefined') {
							// Extended value
							if ((this._list_ext.get(row).get(column) + '').match(regex) !== null) {
								// We found a match in this field
								return true
							}

						} else {
							// Standard value
							if ((row[column.field] + '').match(regex) !== null) {
								// We found a match in this field
								return true
							}
						}
					}
				})
			})
		}

		// If hidden selection is not allowed..
		let focus = false
		if (this.params.hiddenselect !== true) {
			// ..deselect filtered (hidden) rows
			let new_selection = []
			for (let row of this.selected_rows) {
				if (this.map.includes(row)) {
					// This row is hidden
					new_selection.push(row)
				}
			}
			this.selected_rows = new_selection

			// If we are not in multiselect mode and force-select is on..
			if (this.params.multiselect !== true && this.params.forceselect == true) {
				// ..and we have nothing selected, but could..
				if (this.selected_rows.length == 0 && this.map.length > 0) {
					// ..then select the first row
					this.selected_rows.push(this.map[0])
				}
			}

			// Update footer
			$(this.tfoot_selection).text(this.selected_rows.length)

			// See if we have an action set for this
			if ('onselect' in this.params && typeof this.params.onselect == 'function') {
				this.params.onselect(this.selected_rows, this)
			}

			focus = true
		}

		// Force a complete re-render
		$(this.tbody).empty()
		this._r_rows = {}
		this._r_first = -1
		this._r_last = -1

		// Update extra footer
		if ('render_footer' in this.params && typeof this.params.render_footer == 'function') {
			$(this.extra_footer).html(this.params.render_footer(this._list, this.map))
		}

		// Continue update with sort
		this.sort()

		// Focus on first selected element
		if (focus && this.selected_rows.length > 0) {
			// See if the selected element is visible under the current filter
			let offset = this.map.indexOf(this.selected_rows[0])
			if (offset > -1) {
				let fr = $(this.base).height(),				// frame height
					th = $(this.thead).height(),			// thead height
					tf = $(this.tfoot).height(),			// tfoot height
					ct = fr - th - tf,						// content area height
					rh = (('row_height' in this.params) ? this.params.row_height : 28.5)	// row height

				this.content.scrollTop = (rh * offset) - ((ct - rh) / 2)
			}
		}
	}

	// Update: step 2
	sort () {

		// Run sort
		this.map.sort((a, b) => {

			for (let item of this.sort_order) {
				// Apply the sorting rule of the given column

				// Note: This mechanism is sorting the underlying data not the rendered values.
				let column = this.columns[item.column_id]

				if (typeof column.value !== 'undefined') {
					// Apply rule - extended value
					if (this._list_ext.get(a).get(column) > this._list_ext.get(b).get(column)) return (item.order == 'asc' ? 1 : -1)
					if (this._list_ext.get(a).get(column) < this._list_ext.get(b).get(column)) return (item.order == 'asc' ? -1 : 1)
				} else {
					// Apply rule - standard value
					if (a[column.field] > b[column.field]) return (item.order == 'asc' ? 1 : -1)
					if (a[column.field] < b[column.field]) return (item.order == 'asc' ? -1 : 1)
				}

				// If we reach this point, this rule could not make a distinction, so we go to the next one.
			}

			// Signal, that no distinction could be made
			return 0
		})

		// Render header
		$(this.thead).find('.sort')
			.removeClass('asc desc')
		$(this.thead).find('.sort i')
			.removeClass('fa-sort-up fa-sort-down')
			.addClass('fa-sort')

		for (let i = 0; i < this.sort_order.length; i++) {
			let th = $(this.thead).find(`th:nth-child(${this.sort_order[i].column_id + 1})`)
			th.find('.sort .badge')
				.text((i + 1))
			th.find('.sort')
				.addClass(this.sort_order[i].order)
			th.find('.sort i')
				.removeClass('fa-sort')
				.addClass(this.sort_order[i].order == 'asc' ? 'fa-sort-up' : 'fa-sort-down')
		}

		// Continue update with content render
		this.render()
	}

	// Ellenőrizzük, hogy mobilos nézetben vagyunk-e
	isMobileView () {
		const mobileBreakpoint = this.params.mobile_breakpoint || 992; // lg breakpoint
		return window.innerWidth < mobileBreakpoint;
	}

	setMode (mode = 'list') {
		if (mode == 'map') {
			this._map_mode = true

			// Add map-mode class
			this.base.classList.add('map-mode')

			// Refresh leaflet size
			this._leaflet.invalidateSize()

			// Clear selection, if any (this will also trigger a render)
			this.select()

		} else {

			this._map_mode = false

			// Remove map-mode class
			this.base.classList.remove('map-mode')

			this.render()
		}
	}

	// Update: step 3
	/* Re-render the dynamic grid contents. This is a virtual renderer implementation.
	 */
	render (scroll_only = false) {

		if (this._map_mode) {
			// Térkép nézet esetén a markereket kell frissíteni

			// Markerek eltávolítása
			this._leaflet_markers = []
			if (this._leaflet_mcg) {
				this._leaflet.removeLayer(this._leaflet_mcg)
			}

			// Markercsoport újrainicializálása
			if (this._map_collapse_markers) {
				this._leaflet_mcg = L.markerClusterGroup({
					showCoverageOnHover: false,
					animate: false,
					maxClusterRadius: 40,
					iconCreateFunction: function(cluster) {
						return L.divIcon({
							html: '<b>' + cluster.getChildCount() + '</b>'
						});
					}
				})
			} else {
				this._leaflet_mcg = L.layerGroup()
			}

			// Markerek előkészítése
			const markers = this.params.map.markers(this.map)
			for (const el of markers) {
				const marker_style = {
					icon: L.AwesomeMarkers.icon({
						icon: 'fa-cash-register',
						markerColor: el.color || 'gray',
						prefix: 'fa',
						extraClasses: 'mt-2 pt-1'
					})
				}
				const marker = L.marker(el.geo_coords, marker_style)
				if (el.tooltip) {
					marker.bindTooltip(el.tooltip)
				}
				if (el.popup) {
					marker.bindPopup(el.popup)
				}
				this._leaflet_markers.push(marker)
			}

			// Frissítjük a láblécet
			$(this.tfoot_view_map).text(`${markers.length}`);

			// Markerek hozzáadása (bulk)
			for (const marker of this._leaflet_markers) {
				this._leaflet_mcg.addLayer(marker)
			}
			this._leaflet.addLayer(this._leaflet_mcg)

			// Térkép nézetnél nem rendereljük a táblázatot, kilépünk
			return
		}

		// Ellenőrizzük a mobilos nézetet
		this._isMobileView = this.isMobileView();

		// Az oszlopok kiválasztása a nézetnek megfelelően
		const activeColumns = this._isMobileView && this.mobileColumns.length > 0 ?
			this.mobileColumns : this.columns;

		// A sormagasság kiválasztása a nézetnek megfelelően
		const rh = this._isMobileView && this.params.mobile_row_height ?
			this.params.mobile_row_height :
			(('row_height' in this.params) ? this.params.row_height : 28.5);

		// Get component dimensions
		let fr = $(this.base).height(),				// frame height
			th = $(this.thead).height() || 29,		// thead height
			tf = $(this.tfoot).height() || 29,		// tfoot height
			ct = fr - th - tf,						// content area height
			st = $(this.content).scrollTop(),		// vertical scroll offset
			sl = $(this.content).scrollLeft(),		// horizontal scroll offset
			max_st = Math.max(0, this.map.length * rh - ct) + 25;

		// Set the content area height
		$(this.content).height(ct);

		// Set the header vertical offset
		$(this.thead).parent().css('left', -sl);

		// Check to see if the scroll offset is beyond bounds
		if (st > max_st) {
			$(this.content).scrollTop(max_st);
			console.log('scroll out of bounds', st, max_st);
			return;
		}

		// Determine elements to render
		let first = Math.max(0, Math.min(this.map.length - 1 - Math.ceil(ct / rh), Math.floor(st / rh))),	// first visible row
			last = Math.max(0, Math.min(this.map.length - 1, first + Math.ceil(ct / rh))),					// last visible row
			mt = first * rh, 							// margin top
			mb = (this.map.length - last - 1) * rh;		// margin bottom

		// Margins simulate the presence of rows that are not rendered
		$(this.table).css({ 'margin-top': mt, 'margin-bottom': mb });

		// Side-scroll

		// If all relevant lines are already visible, and we're just scrolling slighty, don't render anything
		if (scroll_only && first >= this._r_first && last <= this._r_last) return;

		if (!scroll_only) {
			// We want to redraw all rows no matter what, so we start clean
			$(this.tbody).empty();
			this._r_rows = {};
			this._r_first = -1;
			this._r_last = -1;

			// Fejléc újrarenderelése, csak akkor ha nem scroll (teljes render)
			this.renderHeader();
		}

		// Update footer
		$(this.tfoot_view).text(`${Math.min(first + 1, this.map.length)} - ${Math.min(last + 1, this.map.length)} / ${this.map.length}`);

		// If the table is empty, there is nothing to render
		if (this.map.length < 1) {
			this._r_first = -1;
			this._r_last = -1;
			return;
		}

		// Iterate over all rows that should be visible
		let prepend = [];
		for (let i = first; i <= last; i++) {
			if (scroll_only) {
				var mode = null;
				if (i < this._r_first) {
					mode = 'p';
				} else if (i > this._r_last) {
					mode = 'a';
				} else {
					continue; // Skip, already visible
				}
			}

			let row = this.map[i];
			var tr = $(`<tr grid_offset="${i}"></tr>`);
			if (i % 2 == 1) {
				tr.addClass('odd');
			}
			if (this.selected_rows.includes(row)) {
				tr.addClass('selected');
			}
			if (this.params.row_class != undefined) {
				tr.addClass(this.params.row_class(row));
			}
			if (!this._isMobileView) {
				tr.addClass('desktop');
			}

			// Prepare columns - most az aktív oszlopokkal dolgozunk (mobilos vagy asztali)
			for (let column of activeColumns) {
				var td_class = '';
				if (column.options && column.options.class) {
					if (typeof column.options.class == 'function') {
						td_class = column.options.class(row, column.field);
					} else {
						td_class = column.options.class;
					}
				}

				// Ha mobilos oszlopot renderelünk, biztosítsuk, hogy a width auto legyen
				const columnWidth = this._isMobileView && column.width === 'auto' ?
					'100%' : `${column.width}px`;

				if (typeof column.value !== 'undefined') {
					// This is an extended field, value is in the cache
					tr.append(`<td style="min-width:${columnWidth}; max-width:${columnWidth};" ${td_class ? `class="${td_class}"` : ''}>${column.type.render(this._list_ext.get(row).get(column), row, column.options, this.map, i, this)}</td>`);
				} else if (column.field === null) {
					// No field specified, just pass null
					tr.append(`<td style="min-width:${columnWidth}; max-width:${columnWidth};" ${td_class ? `class="${td_class}"` : ''}>${column.type.render(null, row, column.options, this.map, i, this)}</td>`);
				} else {
					if (!(column.field in row)) {
						// That field is not right
						console.warn(`The field '${column.field}' is not in the provided row.`);
						tr.append(`<td style="min-width:${columnWidth}; max-width:${columnWidth};" ${td_class ? `class="${td_class}"` : ''}>${column.type.render(null, row, column.options, this.map, i, this)}</td>`);
					} else {
						// Render with field value
						tr.append(`<td style="min-width:${columnWidth}; max-width:${columnWidth};" ${td_class ? `class="${td_class}"` : ''}>${column.type.render(row[column.field], row, column.options, this.map, i, this)}</td>`);
					}
				}
			}

			tr.append(`<td style="width:100%;"></td>`);

			if (!scroll_only || mode == 'a') {
				this._r_rows[i] = tr.appendTo(this.tbody);
			} else {
				prepend.unshift(tr);
				this._r_rows[i] = tr;
			}
		}

		if (scroll_only) {
			for (let tr of prepend) {
				tr.prependTo(this.tbody);
			}

			// Remove excess
			for (let i of Object.keys(this._r_rows)) {
				if (i < first || i > last) {
					this._r_rows[i].remove();
					delete this._r_rows[i];
				}
			}
		}

		// Header widths - mobilos/asztali nézettől függően
		let td_arr = this.tbody.querySelectorAll('tr[grid_offset]:first-child > td');
		let th_arr = this.thead.querySelectorAll('th');
		for (let i = 0; i < td_arr.length - 1; i++) {
			let w = $(td_arr[i]).width() + parseFloat($(td_arr[i]).css('padding-left')) + parseFloat($(td_arr[i]).css('padding-right'));
			$(th_arr[i]).css({ 'min-width': w, 'width': w });
		}

		this._r_first = first;
		this._r_last = last;
	}

	// Különálló függvény a fejléc renderelésére
	renderHeader() {
		// Az oszlopok kiválasztása a nézetnek megfelelően
		const activeColumns = this._isMobileView && this.mobileColumns.length > 0 ?
			this.mobileColumns : this.columns;

		// Fejléc törlése
		$(this.thead).find('tr').empty();

		// Oszlopok hozzáadása
		for (let column of activeColumns) {
			const th = $(`<th field="${column.id}" ${column.width ? `style="min-width:${column.width}px; width:${column.width}px;"` : ''}><div class="d-flex justify-content-between align-items-center">${column.title}<div class="sort"><span class="badge bg-light">1</span><i class="fa fa-sort"></i></div></div></th>`);
			$(this.thead).find('tr').append(th);
		}

		// Kitöltő oszlop
		$(this.thead).find('tr').append(`<th style="width:100%;"></th>`);

		// Sortoló ikonok frissítése
		for (let i = 0; i < this.sort_order.length; i++) {
			let th = $(this.thead).find(`th:nth-child(${this.sort_order[i].column_id + 1})`);
			th.find('.sort .badge')
				.text((i + 1));
			th.find('.sort')
				.addClass(this.sort_order[i].order);
			th.find('.sort i')
				.removeClass('fa-sort')
				.addClass(this.sort_order[i].order == 'asc' ? 'fa-sort-up' : 'fa-sort-down');
		}
	}

	destroy () {

		// Unregister event handlers
		$(window).off('resize', this.resizeListener)
		$(this.content).off('scroll', this.scrollListener)
		$(this.base).off('click', 'thead th', this.thClickListener)
		$(this.base).off('contextmenu', 'thead th', this.thContextMenuListener)
		$(this.base).off('click', 'tbody tr', this.trClickListener)
		$(this.base).off('contextmenu', 'tbody tr', this.trContextMenuListener)

		// Clean up the context menu if it exists
		if (this._contextMenu) {
			// The bootstrap-menu plugin doesn't provide a specific destroy method
			// But we can remove the contextmenu handler on the target element
			$('tbody tr').off('contextmenu.bs-contextmenu');
			this._contextMenu = null;
		}

		if (this._contextMenuMobile) {
			$('tbody .mt-context-menu-btn').off('contextmenu.bs-contextmenu');
			this._contextMenuMobile = null;
		}


		this._list = null

		delete this.sizer
		delete this.content
		delete this.table
		delete this.thead
		delete this.tbody
		delete this.tfoot
		delete this.tfoot_total
		delete this.tfoot_view
		delete this.tfoot_selection
		delete this.extra_footer

		if (this.params.map) {
			delete this.tfoot_total_map
			delete this.tfoot_view_map
			delete this.extra_footer_map
			delete this.map_collapse_markers
		}

		super.destroy()
	}

	/* Cell renderer and sorter function library
	 * Function params: (value, row)
	 */
	static CellTypes = {

		default: {
			default_options: { },
			render (value, row, options) {
				if (value === null)
					return options.show_null ? '<span class="badge bg-light">null</span>' : ''

				return value
			}
		},

		string: {
			default_options: {
				cutoff: 20
			},
			render (value, row, options) {
				if (value === null)
					return options.show_null ? '<span class="badge bg-light">null</span>' : ''

				let str = value + ''
				return (str.length > options.cutoff) ? str.substr(0, options.cutoff) + '...' : str
			}
		},

		number: {
			default_options: {
				class: 'text-end',
				format: null
			},
			render (value, row, options) {
				if (value === null)
					return options.show_null ? '<span class="badge bg-light">null</span>' : ''

				if (options.format !== null) {
					return Anvil.numeral(value).format(options.format)
				}

				return value
			}
		},

		currency: {
			default_options: {
				class: 'text-end',
				format: '0,0.00'
			},
			render (value, row, options) {
				if (value === null)
					return options.show_null ? '<span class="badge bg-light">null</span>' : ''

				return Anvil.numeral(parseFloat(value)).format(options.format)
			}
		},

		bool: {
			default_options: { },
			render (value, row, options) {
				if (value === null)
					return options.show_null ? '<span class="badge bg-light">null</span>' : ''

				return (value[0] == 1) ? '<span class="badge badge-success">true</span>'
									   : '<span class="badge badge-primary">false</span>'
			}
		},

		datetime: {
			default_options: {
				format: 'YYYY. MM. DD. HH:mm:ss',
				variant: 'standard'
			},
			render (value, row, options) {
				if (value === null)
					return options.show_null ? '<span class="badge bg-light">null</span>' : ''

				if (options.variant == 'standard')
					return Anvil.moment(new Date(value)).format(options.format)

				if (options.variant == 'relative')
					return Anvil.moment(new Date(value)).fromNow()

				if (options.variant == 'standard+relative')
					return Anvil.moment(new Date(value)).format(options.format) + ' &bullet; ' + Anvil.moment(new Date(value)).fromNow()
			}
		},

		date: {
			default_options: {
				format: 'YYYY. MM. DD.'
			},
			render (value, row, options) {
				if (value === null)
					return options.show_null ? '<span class="badge bg-light">null</span>' : ''

				return Anvil.moment(new Date(value)).format(options.format)
			}
		}
	}
}
